import React from "react";
import PayoutWorkspace from "./PayoutWorkspace";
const ReportPayout = props => <PayoutWorkspace mode="report" {...props} />;
export default ReportPayout;
